import { TranslationKeys } from '~frontend-common/i18n/english/auto-generated-helper.i18n';

const keys: TranslationKeys = {
  autoGeneratedHelper: {
    cell: {
      // Payment question
      padPaymentHelper: {
        title: '',
        description:
          '<2>Relevé de compte bancaire</2> <1></1> Vous pouvez trouver les numéros sur le relevé de compte de votre banque ou sur votre compte en ligne. <1></1> Votre <0>numéro de transit</0> est un numéro à 5 chiffres. <1></1> Votre <0>numéro de compte</0> est un numéro de 7 à 12 chiffres. <1></1> <2>Specimen de chèque</2> <1></1> Les 5 premiers chiffres représentent votre <0>numéro de transit</0>. <1></1> Le deuxième ensemble de chiffres (entre 7 et 12 chiffres) représente votre <0>numéro de compte</0>.',
      },
      homeReconstructionCost: {
        title: '',
        description: '$t(baseSegment.helpers.homeReconstructionCost.cells.homeReconstructionCost.description)', // this is a reference to an existing translation key to avoid duplication
      },
      roofType: {
        asphalt: {
          description:
            'La toiture est constituée de bardeaux d’asphalte. Ce matériau communément noir est le plus utilisé en Amérique du Nord.',
          title: 'Bardeaux d’asphalte',
        },
        clay: {
          description:
            'La toiture est constituée de tuiles faites d’argile, de ciment ou de pierre. La forme des tuiles peut être courbée ou droite.',
          title: 'Tuiles d’argile ou d’ardoise',
        },
        metal: {
          description: 'La toiture est constituée de métal tel que l’aluminium, l’acier, le cuivre et le zinc.',
          title: 'Métal',
        },
        other: {
          description: 'Autre type de toiture qui n’est pas répertorié dans la liste.',
          title: 'Autre',
        },
        rubber: {
          description:
            "La toiture est constituée d'un matériau à base de caoutchouc tel que l'Éthylène Propylène Diène monomère (EPDM) ou le Thermoplastique polyoléfine (TPO).",
          title: 'Caoutchouc',
        },
        tar: {
          description:
            'La toiture est constituée de plusieurs couches alternant entre l’asphalte, le goudron et le gravier. Ce type de toit est toujours plat.',
          title: 'Goudron et gravier',
        },
        wood: {
          description: 'La toiture est constituée de bardeaux de bois.',
          title: 'Bardeaux de bois',
        },
      },
    },
    title: {
      homeReconstructionCost: 'Coût de reconstruction',
      roofType: 'Matériau du toit',
    },
  },
};

export default keys;
